// iOS segmented control: gray rounded track, white selected segment.
export default function SegmentedControl({ options, value, onChange }) {
  return (
    <div className="flex bg-[#E9E9EB] rounded-lg p-0.5 mx-4">
      {options.map((opt) => {
        const label = typeof opt === 'string' ? opt : opt.label;
        const val = typeof opt === 'string' ? opt : opt.value;
        const active = val === value;
        return (
          <button
            key={val}
            type="button"
            onClick={() => onChange(val)}
            className={`flex-1 py-1.5 rounded-md text-[13px] font-medium transition-all ${
              active ? 'bg-white shadow-sm text-gray-900' : 'text-gray-500'
            }`}
          >
            <span className="inline-flex items-center justify-center gap-1.5">
              {label}
              {typeof opt !== 'string' && opt.count > 0 && (
                <span
                  className="min-w-[18px] h-[18px] px-1.5 rounded-full text-white text-[11px] font-bold inline-flex items-center justify-center"
                  style={{ backgroundColor: opt.badgeColor || '#FF3B30' }}
                >
                  {opt.count > 99 ? '99+' : opt.count}
                </span>
              )}
            </span>
          </button>
        );
      })}
    </div>
  );
}
